import { GET } from '@/utils/request'
import Url from './url'

export const cities = async (params: any) => {
  return await GET({
    url: Url.cities,
    params,
    showError: false
  })
//   const res = Request({ url: Url.cities, method: 'GET', data })
//   return await res
}
export const city = async (params: any) => {
  return await GET({
    url: Url.city,
    params,
    showError: false
  })
//   const res = Request({ url: Url.city, method: 'GET', data })
//   return await res
}
